import ServiceApi from "../services/service.api";

const baseServiceUrl = `/api/v1/SupplierWithdrawal`;


const SupplierWithdrawal = {
  getAllUserWithdrawal: (params) => {
    const url = `${baseServiceUrl}/getAllSupplierWithdrawal`;
    return ServiceApi.get(url, { params });
  },
  getUserWithdrawalById: (params) => {
    const url = `${baseServiceUrl}/getUserWithdrawalById`;
    return ServiceApi.get(url, { params });
  },
  getUserWithdrawalStatus: () => {
    const url = `${baseServiceUrl}/getUserWithdrawalStatus`;
    return ServiceApi.get(url);
  },
  updateUserWithdrawal: (data) => {
    const url = `${baseServiceUrl}/updateUserWithdrawalStatus`;
    return ServiceApi.put(url, data);
  },
  createUserWithdrawal: (params) => {
    const url = `${baseServiceUrl}/createUserWithdrawal`;
    return ServiceApi.post(url, params);
  },
  removeAgentWithdrawal: (params) => {
    const url = `${baseServiceUrl}/removeSupplierWithdrawal`;
    return ServiceApi.put(url, params);
  },

};

export default SupplierWithdrawal;


